import { render } from "./App.vue?vue&type=template&id=0cf80a64"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0cf80a64&lang=css"

import exportComponent from "D:\\local_sites\\svn_sandra\\outside_sales_system\\apps\\sales_visits_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__